// 时间戳转换
export const getLocalTime = (nS: number | string): string => {
  const date = new Date(parseInt(nS.toString(), 10) * 1000);
  const year = date.getFullYear();
  const month =
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const h = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
  const m =
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
  const s =
    date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

  return `${year}/${month}/${day} ${h}:${m}:${s}`;
};

//
export const nowInDateBetwen = (d1: string, d2: string) => {
  const dateBegin = new Date(d1); // 将-转化为/，使用new Date
  const dateEnd = new Date(d2); // 将-转化为/，使用new Date
  const dateNow = new Date(); // 获取当前时间

  const beginDiff = dateNow.getTime() - dateBegin.getTime(); // 时间差的毫秒数
  const beginDayDiff = Math.floor(beginDiff / (24 * 3600 * 1000)); // 计算出相差天数

  const endDiff = dateEnd.getTime() - dateNow.getTime(); // 时间差的毫秒数
  const endDayDiff = Math.floor(endDiff / (24 * 3600 * 1000)); // 计算出相差天数

  if (endDayDiff < 0) {
    // 已过期
    return '活动点赞时间已结束';
  }
  if (beginDayDiff < 0) {
    // 没到开始时间
    return '活动点赞时间未开始';
  }
  return true;
};
export function addZero(i: any) {
  return i < 10 ? '0' + i : i + '';
}
export function countDown(date: string) {
  const nowtime: any = new Date();
  const endtime: any = new Date(date);
  const lefttime: any = parseInt(
    String((endtime.getTime() - nowtime.getTime()) / 1000),
    10,
  );
  let d: any = parseInt(String(lefttime / (24 * 60 * 60)), 10);
  let h: any = parseInt(String((lefttime / (60 * 60)) % 24), 10);
  let m: any = parseInt(String((lefttime / 60) % 60), 10);
  let s: any = parseInt(String(lefttime % 60), 10);
  d = addZero(d);
  h = addZero(h);
  m = addZero(m);
  s = addZero(s);
  if (lefttime <= 0) {
    return false;
  }
  return `${d}天 ${h} 时 ${m} 分 ${s} 秒`;
}
